// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","691":"component---src-pages-index-tsx","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"9a44b0c96edc28263ac1","691":"8eb69c58f467832fd712","883":"fa3bb0a8993cb05fc697"}[chunkId] + ".js";
};